// extracted by mini-css-extract-plugin
export default {"root":"BizPageTabMenu__root--kwt4v","rootNoMarginBottom":"BizPageTabMenu__rootNoMarginBottom--2eNZE"};